(function () {
    'use strict';
    /*
     * Copyright (c) 2025 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ModalTextInputCtrl', ModalTextInputCtrl);

    ModalTextInputCtrl.$inject = ['$scope', '$modalInstance', 'message', 'title', 'initialValue', 'placeholder'];

    /**
     * Controller for a text input dialog.
     */
    function ModalTextInputCtrl($scope, $modalInstance, message, title, initialValue, placeholder) {

        $scope.message = message;
        $scope.title = title;
        $scope.inputValue = initialValue;
        $scope.placeholder = placeholder;

        /**
         * Closes the dialog and returns the entered text.
         */
        $scope.ok = function () {
            $modalInstance.close($scope.inputValue);
        };

        /**
         * Closes the dialog without returning a value.
         */
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
